import { hFetch } from '@/lib/hfetch';
import type {
  TeamWorkflowTemplate,
  WorkflowEmailTemplate,
  WorkflowSmsTemplate,
} from './entity_types/TeamWorkflowTemplate';

export type ListTeamWorkflowTemplatesResponse = {
  licensed_job_board_email: TeamWorkflowTemplate<WorkflowEmailTemplate>;
  licensed_job_board_sms: TeamWorkflowTemplate<WorkflowSmsTemplate>;
  licensed_meta_email: TeamWorkflowTemplate<WorkflowEmailTemplate>;
  licensed_meta_sms: TeamWorkflowTemplate<WorkflowSmsTemplate>;
  unlicensed_with_coursework_started_job_board_sms: TeamWorkflowTemplate<WorkflowSmsTemplate>;
};

export const listTeamWorkflowTemplates = () => {
  return hFetch<ListTeamWorkflowTemplatesResponse>({ url: '/api/team/workflow_templates' });
};

type UpdateWorkflowTemplatePayload =
  | {
      subject: string;
      body: string;
      link_text: string;
    }
  | { message: string };

export const updateTeamWorkflowTemplate = async (id: number, payload: UpdateWorkflowTemplatePayload) => {
  return await hFetch<
    TeamWorkflowTemplate<WorkflowEmailTemplate | WorkflowSmsTemplate>,
    { workflow_template: UpdateWorkflowTemplatePayload }
  >({
    url: `/api/team/workflow_templates/${id}`,
    method: 'PATCH',
    payload: { workflow_template: { ...payload } },
  });
};
